import { getSseSource } from './creator';
import { EventType } from './types';
import { handlers } from './';

export function subscribeToEvents(subscribedEvents: EventType[]) {
	const sse = getSseSource();
	if (!sse) return;

	subscribedEvents.forEach((subscription) => {
		sse.addEventListener(
			subscription,
			handlers[subscription] as EventListener
		);
	});
}
